import EcommerceCardFieldEnum from "@models/EcommerceCardFieldEnum";
import { OwSortableList, IOwSortableListItem } from "../../../shared/OwSortableList/OwSortableList";
import OwLabel from "../../../shared/OwLabel/OwLabel";

const FIELD_LABEL_KEYS: Record<EcommerceCardFieldEnum, string> = {
    [EcommerceCardFieldEnum.NAME]: "name",
    [EcommerceCardFieldEnum.SKU]: "sku",
    [EcommerceCardFieldEnum.MSRP]: "msrp",
    [EcommerceCardFieldEnum.PRICE]: "price",
    [EcommerceCardFieldEnum.SHORT_DESCRIPTION]: "short_description",
    [EcommerceCardFieldEnum.LONG_DESCRIPTION]: "long_description",
    [EcommerceCardFieldEnum.CATEGORY]: "category",
    [EcommerceCardFieldEnum.ACTIONS]: "add_to_cart",
};

type Props = {
    fieldOrder: EcommerceCardFieldEnum[];
    visibility: Record<EcommerceCardFieldEnum, boolean>;
    onChange: (fieldOrder: EcommerceCardFieldEnum[], visibility: Record<EcommerceCardFieldEnum, boolean>) => void;
};

/**
 * eCommerce card view field configuration: maps the card-field domain onto the generic
 * OwSortableList (drag to reorder, eye toggle for visibility). The ACTIONS entry is the
 * whole purchase-controls block (qty input, UOM selector, item options, Add To Cart) —
 * draggable as one unit, never hideable.
 */
export const EcommerceCardFieldOrderConfig = (props: Props) => {
    const items: IOwSortableListItem[] = props.fieldOrder.map((field) => ({
        id: field,
        labelKey: FIELD_LABEL_KEYS[field],
        visible: props.visibility[field],
        hideToggle: field === EcommerceCardFieldEnum.ACTIONS,
    }));

    const renderItem = (item: IOwSortableListItem) => {
        if (item.id !== EcommerceCardFieldEnum.ACTIONS) {
            return undefined;
        }

        return (
            <span>
                <OwLabel title={"quantity"} noBottomMargin={true} />
                <span className={"ms-1 me-1"}>/</span>
                <OwLabel title={"add_to_cart"} noBottomMargin={true} />
            </span>
        );
    };

    const onReorder = (ids: string[]) => {
        props.onChange(ids as EcommerceCardFieldEnum[], props.visibility);
    };

    const onToggleVisibility = (id: string) => {
        const field = id as EcommerceCardFieldEnum;

        props.onChange(props.fieldOrder, { ...props.visibility, [field]: !props.visibility[field] });
    };

    return (
        <div className={"EcommerceCardFieldOrderConfig"}>
            <OwLabel title={"drag_items_to_reorder"} className={"text-small text-muted"} />
            <OwSortableList items={items} onReorder={onReorder} onToggleVisibility={onToggleVisibility} renderItem={renderItem} />
        </div>
    );
};
